module.exports = __webpack_public_path__ + "static/Infographic4_2_New_Taipei-b55844ebc7455a88e6418f914dc4c1c4.png";